export const ORDER_STATUS_SAVE = '提交';
export const ORDER_STATUS_DEAL = '已成交';
export const ORDER_STATUS_MANUAL_CLOSE = '人工关闭';
export const ORDER_STATUS_EXPIRES_CLOSE = '超时关闭';

export const ORDER_PAID_STATUS_TYPE_UN_PAID = '未支付';
export const ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID = '定金已支付';
export const ORDER_PAID_STATUS_TYPE_FULL_PAID = '全额支付';

export const ORDER_DELIVERY_STATUS_TYPE_UN_SHIP = '未发货';
export const ORDER_DELIVERY_STATUS_TYPE_SHIP = '已发货';

export const getOrderPaidStatusOptions = () => {
    const status = [
        ORDER_PAID_STATUS_TYPE_UN_PAID,
        ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID,
        ORDER_PAID_STATUS_TYPE_FULL_PAID
    ];

    return status.map(s => {
        return { key: s, value: s };
    });
};

export const getOrderDeliveryStatusOptions = () => {
    const status = [
        ORDER_DELIVERY_STATUS_TYPE_UN_SHIP,
        ORDER_DELIVERY_STATUS_TYPE_SHIP
    ];

    return status.map(s => {
        return { key: s, value: s };
    });
};
